export default {
  important: {
    backgroundColor: 'rgba(255,229,100,0.3)',
    borderLeft: '9px solid rgba(255,229,100,1)',
    paddingTop: '20px',
    paddingRight: '45px',
    paddingBottom: '20px',
    paddingLeft: '26px',
    marginBottom: '30px',
    marginTop: '20px',
  },
  warning: {
    backgroundColor: 'rgba(255, 64, 0, 0.3)',
    borderLeft: '9px solid rgba(255, 64, 0, 1)',
    paddingTop: '20px',
    paddingRight: '45px',
    paddingBottom: '20px',
    paddingLeft: '26px',
    marginBottom: '30px',
    marginTop: '20px',
  },
  info: {
    backgroundColor: 'rgba(100, 203, 255, 0.3)',
    borderLeft: '9px solid rgba(100, 203, 255, 1)',
    paddingTop: '20px',
    paddingRight: '45px',
    paddingBottom: '20px',
    paddingLeft: '26px',
    marginBottom: '30px',
    marginTop: '20px',
  },
  success: {
    backgroundColor: 'rgba(152, 255, 100, 0.3)',
    borderLeft: '9px solid rgba(152, 255, 100, 0.1)',
    paddingTop: '20px',
    paddingRight: '45px',
    paddingBottom: '20px',
    paddingLeft: '26px',
    marginBottom: '30px',
    marginTop: '20px',
  },
};